"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { Logo } from "../ui/logo.js";
export function JellyLogo() {
    var canvas = useRef(null);
    var scene = useRef(null);
    var _a = useState(false), ready = _a[0], setReady = _a[1];
    var _b = useState(false), reduced = _b[0], setReduced = _b[1];
    var interactive = ready && !reduced;
    useEffect(function () {
        if (!canvas.current) {
            return;
        }
        var element = canvas.current;
        var mounted = true;
        var cleanup;
        void import("./jelly-scene.js")
            .then(function (_a) {
            var create = _a.createJellyScene;
            if (!mounted) {
                return;
            }
            var jelly;
            try {
                jelly = create(element);
            }
            catch (error) {
                console.warn("Could not initialize the 404 jelly", error);
                return;
            }
            scene.current = jelly;
            var motion = window.matchMedia("(prefers-reduced-motion: reduce)");
            var updateMotion = function () {
                jelly.setReducedMotion(motion.matches);
                setReduced(motion.matches);
            };
            var updateTheme = function () {
                jelly.setTheme(document.documentElement.classList.contains("dark"));
            };
            var theme = new MutationObserver(updateTheme);
            theme.observe(document.documentElement, {
                attributes: true,
                attributeFilter: ["class"],
            });
            motion.addEventListener("change", updateMotion);
            updateMotion();
            updateTheme();
            void jelly.ready
                .then(function () {
                if (mounted && scene.current === jelly) {
                    setReady(true);
                }
            })
                .catch(function (error) {
                console.warn("Could not load the 404 jelly studio", error);
                jelly.dispose();
                if (scene.current === jelly) {
                    scene.current = null;
                }
            });
            var contextLost = function (event) {
                event.preventDefault();
                jelly.dispose();
                scene.current = null;
                setReady(false);
            };
            element.addEventListener("webglcontextlost", contextLost);
            cleanup = function () {
                theme.disconnect();
                motion.removeEventListener("change", updateMotion);
                element.removeEventListener("webglcontextlost", contextLost);
                jelly.dispose();
                scene.current = null;
            };
        })
            .catch(function (error) {
            console.warn("Could not load the 404 jelly", error);
        });
        return function () {
            mounted = false;
            cleanup === null || cleanup === void 0 ? void 0 : cleanup();
        };
    }, []);
    return (_jsxs("div", { className: "mx-auto w-full max-w-[760px]", children: [_jsxs("div", { className: "relative aspect-square rounded-3xl has-[:focus-visible]:ring-2 has-[:focus-visible]:ring-ring sm:aspect-[4/3]", children: [!ready && (_jsxs("div", { "aria-hidden": "true", className: "absolute inset-0 flex items-center justify-center", children: [_jsx("span", { className: "absolute font-sans text-[clamp(140px,29vw,280px)] font-semibold tracking-tighter text-foreground/5", children: "404" }), _jsx(Logo, { className: "relative w-[30%] text-foreground/30" })] })), _jsx("canvas", { ref: canvas, className: "absolute inset-0 h-full w-full outline-none", style: {
                            opacity: ready ? 1 : 0,
                            pointerEvents: interactive ? "auto" : "none",
                            touchAction: interactive ? "none" : "pan-y",
                            maskImage: "linear-gradient(to bottom, black 80%, transparent 100%)",
                        }, role: interactive ? "button" : "img", tabIndex: interactive ? 0 : undefined, "aria-label": interactive
                            ? "Squish the jelly LLM Gateway logo"
                            : "LLM Gateway logo", "aria-describedby": interactive ? "jelly-hint" : undefined, onKeyDown: function (event) {
                            var _a;
                            if (interactive && (event.key === "Enter" || event.key === " ")) {
                                event.preventDefault();
                                (_a = scene.current) === null || _a === void 0 ? void 0 : _a.bounce();
                            }
                        } })] }), _jsx("p", { id: "jelly-hint", className: "h-5 text-center text-xs text-muted-foreground", style: { visibility: ready && !reduced ? "visible" : "hidden" }, children: "Drag to stretch. Click or press Enter to squish." })] }));
}
//# sourceMappingURL=jelly-logo.js.map